module.exports = __webpack_public_path__ + "templates.store_pick_up_options-183e3c6d.html";